import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/layout/Layout";
import LocaleSync from "@/components/common/LocaleSync";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Products from "@/pages/Products";
import ProductCategory from "@/pages/ProductCategory";
import Industries from "@/pages/Industries";
import ExportSolutions from "@/pages/ExportSolutions";
import CustomSourcing from "@/pages/CustomSourcing";
import ImportBusiness from "@/pages/ImportBusiness";
import GlobalPartner from "@/pages/GlobalPartner";
import Government from "@/pages/Government";
import Resources from "@/pages/Resources";
import ExportfyAI from "@/pages/ExportfyAI";
import Consultation from "@/pages/Consultation";
import Contact from "@/pages/Contact";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import NotFound from "@/pages/NotFound";
import { NON_DEFAULT_CODES } from "@/i18n/config";
import "@/App.css";

const ROUTES = [
    { path: "", element: <Home /> },
    { path: "about", element: <About /> },
    { path: "products", element: <Products /> },
    { path: "products/:slug", element: <ProductCategory /> },
    { path: "industries", element: <Industries /> },
    { path: "export-solutions", element: <ExportSolutions /> },
    { path: "custom-sourcing", element: <CustomSourcing /> },
    { path: "import-business", element: <ImportBusiness /> },
    { path: "global-partner", element: <GlobalPartner /> },
    { path: "government", element: <Government /> },
    { path: "resources", element: <Resources /> },
    { path: "exportfy-ai", element: <ExportfyAI /> },
    { path: "consultation", element: <Consultation /> },
    { path: "contact", element: <Contact /> },
    { path: "privacy", element: <Privacy /> },
    { path: "terms", element: <Terms /> },
];

function App() {
    return (
        <BrowserRouter>
            <LocaleSync />
            <Layout>
                <Routes>
                    {/* Default (English) — no prefix, preserves existing URLs */}
                    {ROUTES.map((r) => (
                        <Route key={`en-${r.path}`} path={`/${r.path}`} element={r.element} />
                    ))}
                    {/* Locale-prefixed variants for the other 10 languages */}
                    {NON_DEFAULT_CODES.map((code) => (
                        <Route key={code} path={`/${code}`}>
                            {ROUTES.map((r) => (
                                <Route
                                    key={`${code}-${r.path}`}
                                    path={r.path}
                                    element={r.element}
                                />
                            ))}
                        </Route>
                    ))}
                    <Route path="*" element={<NotFound />} />
                </Routes>
            </Layout>
            <Toaster position="top-right" richColors closeButton />
        </BrowserRouter>
    );
}

export default App;
